import { useState } from 'react';
import { useDidMount, useLocalstorageState } from 'rooks';
import Pusher from 'pusher-js';
import PusherContext from './_context';
import { useGetAuthorizationToken } from '@/app/authentication/_hooks';
import { getApiUrl } from '@/helpers/api';
import { useSelf } from '@/data/user';
import { PageLoading } from '@/app/ui/page';

const PUSHER_ENABLED = process.env.PUSHER_ENABLED !== false;

const PusherProvider = ({ children }) => {
  const [pusherClient, setPusherClient] = useState(null);
  const getAuthorizationToken = useGetAuthorizationToken();
  const self = useSelf(false);
  const [activeCompanyUid] = useLocalstorageState('active-company-uid', null);

  useDidMount(async () => {
    if (!PUSHER_ENABLED) return;

    try {
      const token = await getAuthorizationToken();
      const pusher = new Pusher('ba439fc1e1b1f4f8c2bf', {
        cluster: 'us3',
        channelAuthorization: {
          endpoint: `${getApiUrl()}/pusher/user-auth`,
          headers: {
            Authorization: `Bearer ${token}`,
            ...(self.data.is_zebeler && activeCompanyUid ? { 'company-uid': activeCompanyUid } : {})
          }
        }
      });
      setPusherClient(pusher);

      return () => {
        pusher.disconnect();
      };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to initialize Pusher:', error);
    }
  }, []);

  if (PUSHER_ENABLED && !pusherClient) {
    return <PageLoading />;
  }

  return <PusherContext.Provider value={{ pusherClient }}>{children}</PusherContext.Provider>;
};

export default PusherProvider;
